import React from 'react';
import { PickedFamilyMember } from './ShareChildrenWrapper';
// @ts-ignore
import styles from './ShareChildrenStep2.module.scss';
import Button from '../../../../BaseModule/Components/Button/Button/Button';
import { default as SubmitButton } from '../../../../BaseModule/Components/Button';
import { useFamilyMemberRelationMutation } from '../../../../../graphql/graphql';
import useNotification from '../../../../../Hooks/useNotification';
import useTranslation from '../../../../../Hooks/useTranslation';
import Text from '../../../../BaseModule/Components/Text';

interface Props {
	onCancel: () => void;
	onSuccess: () => void;
	pickedFamilyMember: PickedFamilyMember;
	childrenId: string;
}

const ShareChildrenStep2: React.FC<Props> = ({
	onCancel,
	onSuccess,
	pickedFamilyMember,
	childrenId,
}) => {
	const { showNotificationAlert, showNotificationSuccess } = useNotification();
	const { t } = useTranslation();
	const [createFamilyMemberRelation] = useFamilyMemberRelationMutation();
	const handleReject = () => {
		onCancel();
	};

	const handleAccept = async () => {
		try {
			const result = await createFamilyMemberRelation({
				input: {
					userId: pickedFamilyMember.id,
					relatedUserId: childrenId,
				},
			}).unwrap();
			if (result) {
				showNotificationSuccess({
					content: t('component.shareChildren.successMessage'),
				});
				onSuccess();
			}
		} catch (e: any) {
			if (e.response.data.displayableError) {
				showNotificationAlert({
					content: e.response.data.message,
				});
			}
		}
	};

	return (
		<div className={styles.wrapper}>
			<Text tx='component.shareChildren.step2.text' className={styles.text} />
			<Button
				title={pickedFamilyMember.fullName}
				icon={pickedFamilyMember.profileImageUrl}
				showArrow={false}
			/>
			<div className={styles.buttonsWrapper}>
				<SubmitButton onClick={handleReject} text='base.no' />
				<SubmitButton className='green' onClick={handleAccept} text='base.yes' />
			</div>
		</div>
	);
};

export default ShareChildrenStep2;
